// ...src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import setLoading from '../../Redux/Slices/Utility/loaderSlice';
import ColumnConfigSlice from '../../Redux/Slices/Utility/ColumnConfigSlice';
import loginSlice from '../Slices/Utility/LoginSlice';
import UserMenuPermission from '../Slices/Utility/MenuPermition';
import MenuMastSlice from '../Slices/Masters/MenuMastSlice';
import DynamicSlice from '../Slices/Transaction/DynamicSlice';
import SPNameMastSlice from '../../Redux/Slices/Masters/SPNameMastSlice';
import PacketSearchSlice from '../Slices/Masters/PacketSearchSlice';
import DropDownSlice from '../Slices/Utility/DropDownSlice';
import UserProfileSlice from '../Slices/Utility/UserProfileSlice'; 
export default configureStore({
    reducer: {
        MenuMaster: MenuMastSlice,
        DynamicEnt: DynamicSlice,
        DynamicEntSum: DynamicSlice,
        SPNameMast: SPNameMastSlice,
        ColumnConfig: ColumnConfigSlice,
        Loader: setLoading,
        MenuPermition: UserMenuPermission,
        UserLogin: loginSlice,
        PacketSearch: PacketSearchSlice,
        DropDown: DropDownSlice,
        UserProfile: UserProfileSlice

    },
});